import React, { Component, useState, useEffect, useRef } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import Select from "react-select";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import { Row, Col, Card, Dropdown, Button, Typography, Drawer, Modal, Input } from "antd";
import { faArrowAltCircleLeft, faClock, faEdit, faEnvelope, faPaperPlane, faPrint, faTasks, faUserCircle, faUserPlus } from "@fortawesome/free-solid-svg-icons";

function InvoicePreview(props) {
  const [invoice, setInvoice] = useState(null);
  const [invoiceLineItems, setInvoiceLineItems] = useState([]);
  const [invoiceTimeEntries, setInvoiceTimeEntries] = useState([]);
  const [company, setCompany] = useState(null);
  const [imageRefresher, setImageRefresher] = useState(uuidv4());

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [newEmailToAuthenticate, setNewEmailToAuthenticate] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [clientContacts, setClientContacts] = useState([]);
  const [authenticatedSenders, setAuthenticatedSenders] = useState([]);

  const [emailSettings, setEmailSettings] = useState({ to: [], from: [] });
  const [emailInProgress, setEmailInProgress] = useState(false);

  const params = useParams();
  const location = useLocation();

  const printableRef = useRef();

  const GetInvoice = async () => {
    let response = await props.AxiosRequest("/api/invoices/get", { tag: params.invoice_tag });
    setInvoice(response.data.invoices[0]);
  };
  const GetInvoiceLineItems = async () => {
    let response = await props.AxiosRequest("/api/invoices/get/line-items/by-invoice", { invoice_id: invoice?.id });
    setInvoiceLineItems(response.data.invoice_line_items);
  };
  const GetTimeEntries = async () => {
    let response = await props.AxiosRequest("/api/time-entries/get", { invoices_xref: invoice?.id });
    setInvoiceTimeEntries(response.data.time_entries);
  };
  const GetCompany = async () => {
    let response = await props.AxiosRequest("/api/companies/get");
    setCompany(response.data.company);
  };

  const GetClientContacts = async () => {
    let response = await props.AxiosRequest("/api/client-contacts/get", { client_id: invoice.clients_xref });
    setClientContacts(
      response.data.client_contacts
        .filter((f) => f.email)
        .map((m) => {
          return { ...m, value: m.id, label: m.name + " (" + m.email + ")", isDisabled: m.can_email === 1 ? false : true };
        }),
    );
  };
  const GetAuthenticatedSenders = async () => {
    let response = await props.AxiosRequest("/api/authenticated-senders/get");
    setAuthenticatedSenders(
      response.data.authenticated_senders.map((m) => {
        return { ...m, value: m.id, label: m.email };
      }),
    );
  };
  const AddAuthenticatedSender = async () => {
    await props.AxiosRequest("/api/authenticated-senders/insert", { email: newEmailToAuthenticate });
  };
  const SendInvoiceViaEmail = async () => {
    if (!emailSettings.from) return props.MakeNotification("warning", "Please select a 'From' email address.");
    if (!emailSettings.to || !emailSettings?.to.length) return props.MakeNotification("warning", "Please select a 'To' email address or addresses.");
    setEmailInProgress(true);
    let canvas = await html2canvas(printableRef.current, { scale: 2, allowTaint: false, useCORS: true });
    canvas.toBlob(async (blob) => {
      // this function doesn't support async/await... :(
      let fd = new FormData();
      fd.append("file", blob, invoice?.clients_tag + "-" + invoice?.tag);
      let response = await Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/invoices/upload", fd, {
        headers: { "content-type": "multipart/form-data" },
      });

      if (response.data.status === "error") return props.MakeNotification("error", response.data.message || "There was a backend error. Please try again.");
      if (response.data.status === "success") {
        let r2 = await props.AxiosRequest("/api/invoices/email", {
          to_emails: emailSettings.to,
          from_email: emailSettings.from,
          invoice_id: invoice?.id,
          now: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        });
        if (r2.data.status === "success") setEmailSent(true);
        setEmailInProgress(false);
      }
    });
  };

  useEffect(() => {
    GetInvoice();
    GetCompany();
    GetAuthenticatedSenders();
  }, []);

  useEffect(() => {
    if (invoice?.id) GetInvoiceLineItems();
    if (invoice?.id && location.pathname.indexOf("with-details") > 0) GetTimeEntries();
  }, [invoice?.id]);

  useEffect(() => {
    if (invoice?.clients_xref) GetClientContacts();
  }, [invoice?.clients_xref]);

  return (
    <div className="container">
      <Row gutter={[16, 16]} className="mt-2 mb-4">
        <Col span={8} className="text-center">
          <Dropdown
            menu={{
              items: [
                {
                  key: 0,
                  label: (
                    <Link to={"/invoicing/" + invoice?.tag}>
                      <FontAwesomeIcon icon={faEdit} className="mr-1" />
                      To Invoice
                    </Link>
                  ),
                },
                {
                  key: 1,
                  label: (
                    <Link to={"/client-details/" + invoice?.clients_tag}>
                      <FontAwesomeIcon icon={faUserCircle} className="mr-1" />
                      To Client
                    </Link>
                  ),
                },
                {
                  key: 2,
                  label: (
                    <Link to={{ pathname: "/time-sheet" }}>
                      <FontAwesomeIcon icon={faClock} className="mr-1" />
                      To Time Sheet
                    </Link>
                  ),
                },
                {
                  key: 3,
                  label: (
                    <Link to={{ pathname: "/task-board" }}>
                      <FontAwesomeIcon icon={faTasks} className="mr-1" />
                      To My Board
                    </Link>
                  ),
                },
              ],
            }}
          >
            <Button>
              <FontAwesomeIcon icon={faArrowAltCircleLeft} className="pe-none mr-2" />
              Go Back
            </Button>
          </Dropdown>
        </Col>
        <Col span={8} className="text-center">
          <ReactToPrint
            trigger={() => (
              <Button>
                <FontAwesomeIcon icon={faPrint} className="mr-1" /> Print Invoice
              </Button>
            )}
            content={() => printableRef.current}
          />
        </Col>
        <Col span={8} className="text-center">
          <Button
            onClick={() => {
              setDrawerOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} className="mr-1" /> Email Invoice
          </Button>
        </Col>
      </Row>
      <div className="d-flex justify-content-center">
        <div style={{ width: "210mm", minHeight: "260mm", margin: "auto", pageBreakAfter: "auto" }} ref={printableRef}>
          <div className="invoice-body">
            <Card style={{ pageBreakAfter: "always" }}>
              <Row gutter={[16, 16]}>
                <Col span={10} style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
                  <div style={company?.invoice_image_type === 1 ? { maxWidth: "100%", display: "inline-block" } : { maxWidth: "105px", display: "inline-block" }}>
                    {company?.image_link ? (
                      <img
                        crossOrigin="anonymous"
                        src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + company?.image_link + "?v=" + imageRefresher}
                        style={company?.invoice_image_type === 1 ? { maxWidth: "100%", maxHeight: "99%" } : { maxWidth: "95px", maxHeight: "99%" }}
                        id="user-info-image"
                        className="img-fluid mb-2"
                        alt="User"
                        onError={() => {
                          setImageRefresher(uuidv4());
                        }}
                      />
                    ) : null}
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "15px" }}>
                    <b>{company?.name ? company?.name : null}</b>
                    <br></br>
                    {company?.address_line_1 ? company?.address_line_1 : null}
                    <br></br>
                    {company?.address_line_2 === "" ? company?.address_line_2 : null}
                    {company?.city}, {company?.state} {company?.zip}
                    <br></br>
                  </div>
                </Col>
                <Col span={4}>
                  <Typography.Title level={3}>INVOICE</Typography.Title>
                </Col>
                <Col span={4} className="text-md-end" style={{ textAlign: "right !important", fontSize: "12px" }}>
                  <div>
                    <b>Telephone:</b>
                    <br></br>
                    <b>Fax:</b>
                    <br></br>
                    <b>Website:</b>
                    <br></br>
                    <br></br>
                    <br></br>
                    <b>Invoice:</b>
                    <br></br>
                    <b>Invoice Date:</b>
                    <br></br>
                    <b>Due Date:</b>
                  </div>
                </Col>
                <Col span={6} className="text-md-end" style={{ fontSize: "12px" }}>
                  <div>{company?.telephone || <br />}</div>
                  <div>{company?.fax || <br />}</div>
                  <div>{company?.website || <br />}</div>
                  <br></br>
                  <br></br>
                  <div>{invoice?.id === -1 ? "Not yet saved" : <strong># {invoice?.name}</strong>}</div>
                  <div>{props.MakeDateTimeReadable(invoice?.invoiced_at)}</div>
                  <div>{props.MakeDateTimeReadable(invoice?.due_at)}</div>
                </Col>
              </Row>
              <hr className="my-4"></hr>
              <div className="row mb-4" style={{ marginLeft: ".9in" }}>
                <div className="col-md-6">
                  <strong>{invoice?.clients_name}</strong>
                  <p>
                    {invoice?.clients_address_line_1}
                    <br></br>
                    {invoice?.clients_address_line_2 === "" ? null : (
                      <span>
                        {invoice?.clients_address_line_2}
                        <br></br>
                      </span>
                    )}
                    {invoice?.clients_city ? invoice?.clients_city + ", " + invoice?.clients_state + " " + invoice?.clients_zip : ""}

                    <br></br>
                  </p>
                </div>
                <div className="col-md-6 text-md-end"></div>
              </div>
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Description</th>
                    <th className="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceLineItems.map((e, i) => {
                    return (
                      <tr key={i}>
                        <td>{e.item_description}</td>
                        <td className="text-end">{props.FormatNumberToCurrency(e.total)}</td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <th>Total:</th>
                    <th className="text-end">{invoiceLineItems.length > 0 ? props.FormatNumberToCurrency(invoiceLineItems.reduce((a, b) => a + b.total, 0)) : null}</th>
                  </tr>
                </tfoot>
              </table>
              <div
                className="text-center"
                dangerouslySetInnerHTML={{
                  __html:
                    company?.invoice_footer_text ||
                    `<p className="text-sm">
                        <strong>Thank you for your business!</strong>
                      </p>`,
                }}
              ></div>
            </Card>
            {location.pathname.indexOf("with-details") > 0 ? (
              <Card>
                <Row gutter={[16, 16]}>
                  <Col span={10} style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
                    <div style={company?.invoice_image_type === 1 ? { maxWidth: "100%", display: "inline-block" } : { maxWidth: "105px", display: "inline-block" }}>
                      {company?.image_link ? (
                        <img
                          crossOrigin="anonymous"
                          src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + company?.image_link + "?v=" + imageRefresher}
                          style={company?.invoice_image_type === 1 ? { maxWidth: "100%", maxHeight: "99%" } : { maxWidth: "95px", maxHeight: "99%" }}
                          id="user-info-image"
                          className="img-fluid mb-2"
                          alt="User"
                          onError={() => {
                            setImageRefresher(uuidv4());
                          }}
                        />
                      ) : null}
                    </div>

                    <div style={{ display: "inline-block", marginLeft: "15px" }}>
                      <b>{company?.name ? company?.name : null}</b>
                      <br></br>
                      {company?.address_line_1 ? company?.address_line_1 : null}
                      <br></br>
                      {company?.address_line_2 === "" ? company?.address_line_2 : null}
                      {company?.city}, {company?.state} {company?.zip}
                      <br></br>
                    </div>
                  </Col>
                  <Col span={4}>
                    <Typography.Title level={3}>INVOICE DETAILS</Typography.Title>
                  </Col>
                  <Col span={4} className="text-md-end" style={{ textAlign: "right !important", fontSize: "12px" }}>
                    <div>
                      <b>Telephone:</b>
                      <br></br>
                      <b>Fax:</b>
                      <br></br>
                      <b>Website:</b>
                      <br></br>
                      <br></br>
                      <br></br>
                      <b>Invoice:</b>
                      <br></br>
                      <b>Invoice Date:</b>
                      <br></br>
                      <b>Due Date:</b>
                    </div>
                  </Col>
                  <Col span={6} className="text-md-end" style={{ fontSize: "12px" }}>
                    <div>{company?.telephone || <br />}</div>
                    <div>{company?.fax || <br />}</div>
                    <div>{company?.website || <br />}</div>
                    <br></br>
                    <br></br>
                    <div>{invoice?.id === -1 ? "Not yet saved" : <strong># {invoice?.name}</strong>}</div>
                    <div>{props.MakeDateTimeReadable(invoice?.invoiced_at)}</div>
                    <div>{props.MakeDateTimeReadable(invoice?.due_at)}</div>
                  </Col>
                </Row>
                <hr className="my-4"></hr>
                <div className="row mb-4" style={{ marginLeft: ".9in" }}>
                  <div className="col-md-6">
                    <strong>{invoice?.clients_name}</strong>
                    <p>
                      {invoice?.clients_address_line_1}
                      <br></br>
                      {invoice?.clients_address_line_2 === "" ? null : (
                        <span>
                          {invoice?.clients_address_line_2}
                          <br></br>
                        </span>
                      )}
                      {invoice?.clients_city ? invoice?.clients_city + ", " + invoice?.clients_state + " " + invoice?.clients_zip : ""}

                      <br></br>
                    </p>
                  </div>
                  <div className="col-md-6 text-md-end"></div>
                </div>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>User</th>
                      <th>Comments</th>
                      <th className="text-end">Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceTimeEntries.map((timeEntry, i) => {
                      return (
                        <tr key={i}>
                          <td style={{ verticalAlign: "text-top" }}>{props.MakeDateTimeReadable(timeEntry.time_at)}</td>
                          <td style={{ verticalAlign: "text-top" }}>{timeEntry.time_by}</td>
                          <td style={{ verticalAlign: "text-top", whiteSpace: "pre-line" }}>{timeEntry.comments}</td>
                          <td style={{ verticalAlign: "text-top" }} className="text-end">
                            {props.FormatNumberTwoDecimals(timeEntry.hours)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th></th>
                      <th></th>
                      <th className="text-end">Total:</th>
                      <th className="text-end">{invoiceTimeEntries.length > 0 ? props.FormatNumberTwoDecimals(invoiceTimeEntries.reduce((a, b) => a + b.hours, 0)) : null}</th>
                    </tr>
                  </tfoot>
                </table>
                <div className="text-center">
                  <p className="text-sm">
                    <strong>Thank you for your business!</strong>
                  </p>
                </div>
              </Card>
            ) : null}
          </div>
        </div>
      </div>
      <Drawer title="Email Invoice To Client" placement="bottom" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Row gutter={[16, 16]}>
          <Col span={6} />
          <Col span={12}>
            <label className="col-form-label-sm">From: </label>
            <Select
              placeholder="Email From"
              noOptionsMessage={() => "You don't have any authenticated senders set up. Please click the plus button to add a verified sender."}
              options={authenticatedSenders}
              onChange={(e) => {
                setEmailSettings({ ...emailSettings, from: [e.email] });
              }}
            />
          </Col>
          <Col span={6}>
            <label className="col-form-label-sm">&nbsp;</label>
            <Button
              className="w-100"
              onClick={() => {
                setNewEmailToAuthenticate("");
                setEmailSent(false);
                setModalOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faUserPlus} className="mr-2" /> Add New Authenticated Sender
            </Button>
          </Col>
          <Col span={6} />
          <Col span={12}>
            <label className="col-form-label-sm">To:</label>
            <Select
              isMulti={true}
              placeholder="Email Recipient(s)"
              noOptionsMessage={() => "None of the contacts for this client have email addresses."}
              options={clientContacts}
              onChange={(e) => {
                setEmailSettings({ ...emailSettings, to: e.map((m) => m.email) });
              }}
            />
          </Col>
          <Col span={6}></Col>
          <Col span={6}></Col>
          <Col span={12}>
            <label className="col-form-label-sm">Invoice Link:</label>
            <Input
              type="text"
              onClick={() => {
                if (navigator?.clipboard) {
                  navigator.clipboard.writeText(
                    window.location.protocol +
                      "//" +
                      window.location.hostname +
                      (window.location.port === "3000" ? ":3000" : "") +
                      "/portal/payments-direct/c/" +
                      invoice?.clients_tag +
                      "/i/" +
                      invoice?.tag,
                  );
                  props.MakeNotification("success", "Link Copied to your clipboard");
                }
              }}
              style={{ textAlign: "center" }}
              value={
                invoice?.tag && invoice?.clients_tag
                  ? window.location.protocol +
                    "//" +
                    window.location.hostname +
                    (window.location.port === "3000" ? ":3000" : "") +
                    "/portal/payments-direct/c/" +
                    invoice?.clients_tag +
                    "/i/" +
                    invoice?.tag
                  : "N/A"
              }
              className="form-control"
              readOnly
            />
          </Col>
          <Col span={18} className="text-right">
            <Button type="primary" onClick={SendInvoiceViaEmail} disabled={emailInProgress}>
              <FontAwesomeIcon icon={faPaperPlane} className="mr-2" />
              {emailSent ? "Email Sent!" : "Send Email with Invoice Attached"}
            </Button>
          </Col>
        </Row>
      </Drawer>
      <Modal
        title="Add a New Authenticated Sender"
        open={modalOpen}
        onCancel={() => {
          setModalOpen(false);
          setNewEmailToAuthenticate("");
        }}
        footer={
          <>
            <Button
              onClick={() => {
                setModalOpen(false);
                setNewEmailToAuthenticate("");
              }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={AddAuthenticatedSender}>
              Add Authenticated Sender
            </Button>
          </>
        }
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <label className="col-form-label-sm">E-mail Address</label>
            <Input
              value={newEmailToAuthenticate}
              onChange={(e) => {
                setNewEmailToAuthenticate(e.target.value);
              }}
            />
          </Col>
          {emailSent ? (
            <Col span={24}>
              <p className="mb-3 mt-3 text-center">
                Success! Please check that email address for an email from Amazon Web Services to confirm your ownership of that email address. Once confirmed it can take up to an hour for your
                authenticated sender to show up.
              </p>
            </Col>
          ) : null}
        </Row>
      </Modal>
    </div>
  );
}

export default InvoicePreview;
